// extracted by mini-css-extract-plugin
export default {"add":"Addbudget_add__aGx-D"};